<template>
  <section class="videoSkeleton">
    <skeleton-box class="videoSkeleton-video" />
    <skeleton-box v-if="showControllers" class="videoSkeleton-controller" />
  </section>
</template>
<script>
export default {
  name: 'VideoSkeleton',
  props: {
    showControllers: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.videoSkeleton {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-video {
    flex-grow: 1;
    width: 100%;
    height: calc(100% - 32px);
  }
  &-controller {
    flex-grow: 0;
    flex-shrink: 0;
    width: 20%;
    height: 0;
    margin: 16px 0;
    border-radius: 12px;
  }
}
</style>
